import  { useState, useEffect } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import ReligionAndPhotoSection from "../components/ReligionAndPhotoSection";
import FieldsSection from "../components/FieldsSection";
import PreviewSection from "../components/PreviewSection";
import BackgroundTemplateSelector from "../components/BackgroundTemplateSelector";
import CoverImageSection from "../components/CoverImageSection";
import PageLoader from "../components/loader/PageLoader";
import { useTheme, useMediaQuery } from "@mui/material";
import { Button, Dialog, DialogContent,  } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { TEMPLATES } from "../components/templates";
import BackButton from "../components/utils/BackButton";
import { EXTRA_FIELDS } from "../components/utils/languageExtraFields";
import LanguageSelector from "../components/LanguageSelector";
import { LANG } from "../components/utils/languageConfig";
import { Helmet } from "react-helmet-async";
import SEO from "../components/SEO";

const PAGE_HEIGHT = 240;
const GROUP_HEIGHT = 14;
const ROW_HEIGHT = 10;

export default function CreateBiodata() {
  const location = useLocation();
  const [coverImage, setCoverImage] = useState(null);
  const [validationErrors, setValidationErrors] = useState({}); 
  const [pages, setPages] = useState([]); // ✅ new

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [showPreview, setShowPreview] = useState(false);

  const [scale, setScale] = useState(1);
  useEffect(() => {
  if (location.state?.selectedBg) {
    setSelectedBg(location.state.selectedBg);
  }
}, [location.state]);

useEffect(() => {
  const updateScale = () => {
    const newScale = Math.min(window.innerWidth / 800, 1);
    setScale(newScale);
  };

  updateScale(); // initial
  window.addEventListener("resize", updateScale);

  return () => window.removeEventListener("resize", updateScale);
}, []);
  const [fields, setFields] = useState([
    {id:"Name", group: "Personal Details", label: "Name", value: "", required: true },
    { id: "Date Of Birth", group: "Personal Details", label: "Date Of Birth", value: "", required: true },
    { id: "Time Of Birth", group: "Personal Details", label: "Time Of Birth", value: "" },
    { id: "Place Of Birth", group: "Personal Details", label: "Place Of Birth", value: "" },
    { id: "Religion", group: "Personal Details", label: "Religion", value: "" },
    { id: "Caste", group: "Personal Details", label: "Caste", value: "" },
    { id: "Sub-Cast", group: "Personal Details", label: "Sub-Cast", value: "" },
    { id: "God", group: "Personal Details", label: "God", value: "" },
    { id: "Gotra", group: "Personal Details", label: "Gotra", value: "" },
    { id: "Rashi", group: "Personal Details", label: "Rashi", value: "" },
    { id: "Nakshatra", group: "Personal Details", label: "Nakshatra", value: "" },
    { id: "Gann", group: "Personal Details", label: "Gann", value: "" },
    { id: "Nadi", group: "Personal Details", label: "Nadi", value: "" },
    { id: "Manglik", group: "Personal Details", label: "Manglik", value: "" },
    { id: "Height", group: "Personal Details", label: "Height", value: "" },
    { id: "Complexion", group: "Personal Details", label: "Complexion", value: "" },
    { id: "BloodGroup", group: "Personal Details", label: "Blood Group", value: "" },
    { id: "Hobbies", group: "Personal Details", label: "Hobbies", value: "" },
    { id: "Highest Education", group: "Personal Details", label: "Highest Education", value: "" },
    { id: "College Name", group: "Personal Details", label: "College Name", value: "" },
    { id: "Job/Occupation", group: "Personal Details", label: "Job/Occupation", value: "" },
    { id: "Annual Income", group: "Personal Details", label: "Annual Income", value: "" },
    { id: "Father's Name", group: "Family Details", label: "Father's Name", value: "" },
    { id: "Father's Occupation", group: "Family Details", label: "Father's Occupation", value: "" },
    { id: "Mother's Name", group: "Family Details", label: "Mother's Name", value: "" },
    { id: "Mother's Occupation", group: "Family Details", label: "Mother's Occupation", value: "" },
    { id: "Total Brothers", group: "Family Details", label: "Total Brothers", value: "" },
    { id: "Total Sisters", group: "Family Details", label: "Total Sisters", value: "" },
    { id: "Contact No.", group: "Contact Details", label: "Contact No.", value: "", required: true },
    { id: "Father Contact No.", group: "Contact Details", label: "Father Contact No.", value: "" },
    { id: "Address", group: "Contact Details", label: "Address", value: "" },
  ]);
  
const [language, setLanguage] = useState("en"); // en | hi | mr

const getFieldsByLanguage = (baseFields, language) => {
  const extra = EXTRA_FIELDS[language] || [];

  // avoid duplicates
  const existingLabels = new Set(baseFields.map(f => f.label));

  const filteredExtra = extra.filter(f => !existingLabels.has(f.label));

  return [...baseFields, ...filteredExtra];
};

const finalFields = getFieldsByLanguage(fields, language);

  const bgTemplates = [
    { key: "/HeroTemplates/NewTemp1.jpg", value: "/pdf-bg11.jfif", theme: "light"  },
    { key: "/HeroTemplates/NewTemp2.jpg", value: "/pdf-bg10.jfif", theme: "light" },
    { key: "/HeroTemplates/NewTemp3.jpg", value: "/pdf-bg10.jfif", theme: "light" },
    { key: "/HeroTemplates/NewTemp4.jpg", value: "/pdf-bg9.jfif", theme: "light" },
    { key: "/HeroTemplates/NewTemp5.jpg", value: "/pdf-bg18.jfif", theme: "light" },
    { key: "/HeroTemplates/NewTemp6.jpg", value: "/pdf-bg18.jfif", theme: "light" },
    { key: "/HeroTemplates/Template3.jpg", value: "/pdf-bg4.jpg", theme: "light" },
    { key: "/HeroTemplates/Template6.jpg", value: "/pdf-bg14.jfif", theme: "light" },
    { key: "/HeroTemplates/Template7.jpg", value: "/pdf-bg16.jfif", theme: "light" },
    { key: "/bg18.jfif", value: "/bg18.jfif" , theme: "light"},
    { key: "/bg4.jfif", value: "/bg4.jfif" , theme: "light"},
    { key: "/bg7.jfif", value: "/bg7.jfif" , theme: "dark"},
    { key: "/bg9.jfif", value: "/bg9.jfif" , theme: "light"},
    { key: "/bg12.jfif", value: "/bg12.jfif" , theme: "light"},
    { key: "/bg13.jfif", value: "/bg13.jfif" , theme: "light"},
    { key: "/bg14.jfif", value: "/bg14.jfif" , theme: "light"},
    { key: "/bg15.jfif", value: "/bg15.jfif" , theme: "light"},
  ];

  /* ================= TEMPLATE SELECTION LOGIC ================= */

 const defaultTemplate = TEMPLATES?.[0]?.value || "";

const [selectedBg, setSelectedBg] = useState(
  location.state?.selectedBg || TEMPLATES?.[0]?.value || ""
);
  /* If user navigates from main page again with new selection */
  useEffect(() => {
    if (location.state?.selectedBg) {
      setSelectedBg(location.state.selectedBg);
    }
  }, [location.state]);

  const [profileImage, setProfileImage] = useState(null);
  const [selectedReligionLogo, setSelectedReligionLogo] = useState(null);
  const [isPdfMode, setIsPdfMode] = useState(false);

  useEffect(() => window.scrollTo(0, 0), []);

  useEffect(() => {
  const container = document.getElementById("measure-container");
  if (!container) return;

  const newPages = paginate(container);
  setPages(newPages);
}, [fields, language]);

  const formatDate = (d) =>
    d ? `${d.split("-")[2]}-${d.split("-")[1]}-${d.split("-")[0]}` : "";

  const formatTime = (t) => {
    if (!t) return "";
    let [h, m] = t.split(":");
    h = parseInt(h, 10);
    const ap = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m} ${ap}`;
  };

const handleChange = (id, value) => {
  setFields((prev) =>
    prev.map((f) =>
      f.id === id ? { ...f, value } : f
    )
  );
};

const handleLabelChange = (id, value) => {
  setFields((prev) =>
    prev.map((f) =>
      f.id === id ? { ...f, label: value } : f
    )
  );
};

const deleteField = (id) =>
  setFields((prev) => prev.filter((f) => f.id !== id));

const moveUp = (id) => {
  setFields((prev) => {
    const index = prev.findIndex((f) => f.id === id);
    if (index <= 0) return prev;

    const updated = [...prev];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    return updated;
  });
};

const moveDown = (id) => {
  setFields((prev) => {
    const index = prev.findIndex((f) => f.id === id);
    if (index === -1 || index === prev.length - 1) return prev;

    const updated = [...prev];
    [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
    return updated;
  });
};


const addField = (group) => {
  const newField = {
    id: `field_${Date.now()}`, // ✅ IMPORTANT
    group,
    label: "New Field",
    value: "",
  };

  setFields((prev) => {
    const updated = [];
    let inserted = false;

    prev.forEach((f, idx) => {
      updated.push(f);

      if (
        f.group === group &&
        (!prev[idx + 1] || prev[idx + 1].group !== group) &&
        !inserted
      ) {
        updated.push(newField); // ✅ USE newField here
        inserted = true;
      }
    });

    return updated;
  });
};
const paginate = () => {
  const pages = [];
  let page = [];
  let y = 0;
  let lastGroup = "";

  const PAGE_HEIGHT = 1000;
  const BUFFER = 10;

  const container = document.getElementById("measure-container");
  if (!container) return [];
const visibleFields = filterFieldsByLanguage(fields, language);

  visibleFields.forEach((f) => {
    let elementHeight = 40;

    const temp = document.createElement("div");
    temp.style.fontSize = "16px";
    temp.style.lineHeight = "35px"; // ✅ match preview
    temp.style.width = "500px";     // ✅ match layout
    temp.style.fontFamily = "Arial";
    temp.style.wordBreak = "break-word";

    temp.innerHTML = `
      <div style="display:flex">
        <div style="width:210px">${f.label}:</div>
        <div>${f.value || "-"}</div>
      </div>
    `;

    container.appendChild(temp);
    elementHeight = temp.getBoundingClientRect().height;
    container.removeChild(temp);

    // GROUP
    if (f.group !== lastGroup) {
      const groupHeight = 2;

      const BUFFER = 3;

      if (y + elementHeight + BUFFER > PAGE_HEIGHT) {
        pages.push(page);
        page = [];
        y = 0;
      }

      page.push({ type: "group", text: f.group });
      y += groupHeight;
      lastGroup = f.group;
    }

    // FIELD
    if (y + elementHeight + BUFFER > PAGE_HEIGHT) {
      pages.push(page);
      page = [];
      y = 0;
    }

    page.push({ type: "field", ...f });
    y += elementHeight;
  });

  if (page.length) pages.push(page);

  return pages;
};

const validateFields = () => {
  const errors = {};

  fields.forEach((f) => {
    if (f.required && (!f.value || f.value.trim() === "")) {
      errors[f.label] = true;
    }
  });

  setValidationErrors(errors);

  if (Object.keys(errors).length > 0) {
    const firstError = Object.keys(errors)[0];
    const el = document.getElementById(`field-${firstError}`);

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }

  return Object.keys(errors).length === 0;
};
const handleDownloadPdf = async () => {
  const isValid = validateFields();
  if (!isValid) return;

  // 👇 IMPORTANT: open preview in mobile
  if (isMobile) {
    setShowPreview(true);

    // wait for dialog render
    await new Promise((res) => setTimeout(res, 500));
  }

  generatePdf();
};
const getBiodataName = () => {
  const nameField = fields.find((f) => f.label === "Name");
  return nameField?.value || "";
};

const name = fields.find(f => f.label === "Name")?.value || "";

const generatePdf = async () => {
  setIsPdfMode(true);

  const html2canvas = (await import("html2canvas")).default;
  const { jsPDF } = await import("jspdf");

  const pdf = new jsPDF("p", "mm", "a4");

  // 🔥 Always use hidden desktop render
  const root = document.getElementById("pdf-render-root");
  const pages = root.querySelectorAll(".pdf-page");

  for (let i = 0; i < pages.length; i++) {
    const canvas = await html2canvas(pages[i], {
      scale: 1.5,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.85);

    if (i !== 0) pdf.addPage();

    pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
  }

  pdf.save("Marriage_Biodata.pdf");
  setIsPdfMode(false);
};

  //const pages = paginate();
  const groups = [...new Set(fields.map((f) => f.group))];

const selectedTemplate = TEMPLATES.find(
  t => t.value === selectedBg
);

const filterFieldsByLanguage = (fields, language) => {
  const langConfig = LANG[language]?.fields;

  return fields.filter((f) => {
    if (langConfig?.exclude?.includes(f.label)) return false;

    if (langConfig?.include?.length > 0) {
      return langConfig.include.includes(f.label) || f.required;
    }

    return true;
  });
};




  return (
    <Box sx={{ px: { xs: 1, md: 2 }, py: 2 }}>
      {isPdfMode && <PageLoader />}

      {/* 🔥 ADD HERE */}
      <BackButton fallback="/" />

      {/* 🔥 SEO */}
      <SEO
        title="Free Marriage Biodata Maker Online | PDF Download"
        description="Design and download professional marriage biodata online for free. Easy templates for Hindu, Marathi, and Indian weddings."
        canonical="https://www.marriagebiodata.live/create-biodata"
      />

      <Box
        id="measure-container"
        sx={{
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none",
          width: "600px",
          top: 0,
          left: 0,
          zIndex: -1,
        }}
      />
      <Box
        id="pdf-render-root"
        sx={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          width: "794px", // A4 width
          zIndex: -1,
        }}
      >
        <PreviewSection
          language={language}
          themeType={selectedTemplate?.theme || "dark"}
          isPdfMode={true} // 🔥 force desktop mode
          pages={pages}
          selectedBg={selectedBg}
          profileImage={profileImage}
          formatDate={formatDate}
          formatTime={formatTime}
          selectedReligionLogo={selectedReligionLogo}
          coverImage={coverImage}
          name={getBiodataName()}
        />
      </Box>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
          sx={{
            fontSize: { xs: "1.6rem", md: "2rem" },
            fontWeight: 800,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            color: "#2C2C2C",
          }}
        >
          Create Your Biodata
        </Typography>
      </Box>

      <CoverImageSection
        coverImage={coverImage}
        setCoverImage={setCoverImage}
      />
      <ReligionAndPhotoSection
        selectedReligionLogo={selectedReligionLogo}
        setSelectedReligionLogo={setSelectedReligionLogo}
        profileImage={profileImage}
        setProfileImage={setProfileImage}
      />
      <LanguageSelector value={language} onChange={setLanguage} />

      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}></Box>

        <Grid item xs={12} md={7}>
          <FieldsSection
            language={language}
            groups={groups}
            fields={finalFields}
            handleLabelChange={handleLabelChange}
            handleChange={handleChange}
            moveUp={moveUp}
            moveDown={moveDown}
            deleteField={deleteField}
            addField={addField}
            validationErrors={validationErrors}
            handleDownloadPdf={handleDownloadPdf}
          />
        </Grid>
        {isMobile && (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                mb: 2,
              }}
            >
              <Button
                variant="contained"
                onClick={() => setShowPreview(true)}
                sx={{
                  px: 4,
                  py: 1.2,
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  minWidth: "220px",

                  background: "linear-gradient(135deg,#667eea,#764ba2)",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.15)",

                  "&:hover": {
                    background: "linear-gradient(135deg,#5a67d8,#6b46c1)",
                  },
                }}
              >
                Preview Biodata
              </Button>
            </Box>
          </Grid>
        )}

        {!isMobile && (
          <Grid item xs={12} md={5}>
            <PreviewSection
              language={language}
              themeType={selectedTemplate?.theme || "dark"}
              isPdfMode={isPdfMode}
              pages={pages}
              selectedBg={selectedBg}
              profileImage={profileImage}
              formatDate={formatDate}
              formatTime={formatTime}
              selectedReligionLogo={selectedReligionLogo}
              coverImage={coverImage}
              name={getBiodataName()}
            />
          </Grid>
        )}

        {isMobile && (
          <Dialog
            open={showPreview}
            onClose={() => setShowPreview(false)}
            fullScreen
          >
            <DialogContent
              sx={{
                p: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                overflow: "auto",
                background: "#f5f5f5",
              }}
            >
              <Box
                sx={{
                  transform: {
                    xs: "scale(0.6)",
                    sm: "scale(0.75)",
                    md: "scale(0.9)",
                  },
                  transformOrigin: "top center",
                  width: "fit-content",
                }}
              >
                <PreviewSection
                  language={language}
                  themeType={selectedTemplate?.theme || "dark"}
                  isPdfMode={isPdfMode}
                  pages={pages}
                  selectedBg={selectedBg}
                  profileImage={profileImage}
                  formatDate={formatDate}
                  formatTime={formatTime}
                  selectedReligionLogo={selectedReligionLogo}
                  coverImage={coverImage}
                  name={getBiodataName()}
                />
              </Box>
              <IconButton
                onClick={() => setShowPreview(false)}
                sx={{
                  position: "fixed",
                  top: 12,
                  right: 12,
                  zIndex: 2000,

                  background: "rgba(255,255,255,0.9)",
                  backdropFilter: "blur(6px)",

                  border: "2px solid #ff4d4f",
                  color: "#ff4d4f",

                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",

                  "&:hover": {
                    background: "#ff4d4f",
                    color: "#fff",
                    transform: "scale(1.1)",
                  },

                  transition: "all 0.2s ease",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogContent>
          </Dialog>
        )}
      </Grid>
      <Box
        mt={10}
        pb={10}
        sx={{ borderTop: "1px solid #eee", background: "#fafafa" }}
      >
        <BackgroundTemplateSelector
          templates={TEMPLATES}
          selectedBg={selectedBg}
          onSelect={(template) => {
            if (!template) return;
            setSelectedBg(template.value);
          }}
          enablePreview
          navigateOnSelect={true}
        />
      </Box>
    </Box>
  );
}
